import Modal from '@cp/src/components/Modal/Modal';
import React, { useCallback } from 'react';
import ValidationStep from '../ValidationStep';
import TriggerMockConfirmationStep from './TriggerMockConfirmationStep';
import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';
import ApproveMockModal from './ApproveMockModal';
import { MockStatus, ModalStep } from '../../../types';

interface ITriggerMockModalProps {
  modalState: { isVisible: boolean; currentStep: ModalStep };
  setModalState: (
    value: React.SetStateAction<{
      isVisible: boolean;
      currentStep: ModalStep;
    }>
  ) => void;
}

const TriggerMockModal = (props: ITriggerMockModalProps) => {
  const { modalState, setModalState } = props;
  const { isVisible, currentStep } = modalState;
  const showApproveMockModal = useSelector(
    (state: RootState) =>
      state?.fieldAllocation?.fieldAllocationDetails?.status?.value === MockStatus.COMPLETED
  );

  const updateMockRunStatusLoading = useSelector(
    (state: RootState) => state.fieldAllocation?.updateMockRunStatusLoading
  );

  const handleCloseModal = useCallback(() => {
    setModalState(prev => ({
      ...prev,
      isVisible: false
    }));
  }, []);

  const handleNextStep = useCallback(() => {
    setModalState(prev => ({
      ...prev,
      currentStep: ModalStep.CONFIRM
    }));
  }, []);

  if (showApproveMockModal)
    return <ApproveMockModal handleCloseModal={handleCloseModal} isVisible={isVisible} />;

  return (
    <Modal
      visible={isVisible}
      onClose={handleCloseModal}
      showCloseIcon={false}
      header={
        currentStep === ModalStep.VALIDATE
          ? 'Validate current inputs before you proceed'
          : 'Are you sure you want to trigger mock allocation?'
      }
      headerClassName="!px-6 !pt-6"
      contentClassName="min-w-[460px]"
      closeOnOutsideClick={!updateMockRunStatusLoading}
    >
      {currentStep === ModalStep.VALIDATE ? (
        <ValidationStep handleCloseModal={handleCloseModal} handleNextStep={handleNextStep} />
      ) : (
        <TriggerMockConfirmationStep handleCloseModal={handleCloseModal} />
      )}
    </Modal>
  );
};

export default TriggerMockModal;
